@if (!isMobile) {
    <div class="delete-collections-modal">
        <div class="header-container">
            <div class="header-title">{{'TITLES.DELETE' | translate }}</div>
        </div>
        <div class="content-container">
            <div class="form-container">
                <div class="form-title" rtlDiv>{{'COLLECTION_REPORT.DELETE_CONFIRMATION' | translate }}</div>
                <div>
                    <table class="table" mat-table #table [dataSource]="dataSource" matSort matSortStart="asc"
                        matSortDisableClear matSortActive="bin_name" (matSortChange)="sortData($event)"
                        matSortDirection="desc" rtlDiv>
                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header="bin_name" class="th-title space">
                                {{ 'SITE_MANAGMENT.BIN_NAME' | translate }} </th>
                            <td mat-cell *matCellDef="let element" class="td-value">
                                <span class="cut-txt binNameHref">
                                    {{element ? element.bin_name : ''}}
                                </span>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="clearing">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header="bin_collection_time"
                                class="th-title space"> {{
                                'LIVE_INFO.LIST_COLLECTION_TIME' | translate }} </th>
                            <td mat-cell *matCellDef="let element" class="td-value space">
                                {{currentLang == 'iw' && element ? element.bin_collection_time_he :
                                element.bin_collection_time}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="address">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header="bin_address" class="th-title space">
                                {{ 'LIST_COLUMNS.ADDRESS' | translate }} </th>
                            <td mat-cell *matCellDef="let element" class="td-value space">
                                <span title="{{element ? element.bin_address : ''}}" class="cut-txt">
                                    {{element ? element.bin_address : ''}}
                                </span>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="reason">
                            <th mat-header-cell *matHeaderCellDef class="th-title space">
                                <span rtlDiv>
                                    <span>{{ 'LIST_COLUMNS.REASON' | translate }}</span> 
                                </span>
                            </th>
                            <td mat-cell *matCellDef="let element" class="td-value space">
                                @if (element.is_approved_suspected_as_collection_event != false) {
                                    <mat-form-field class="reason-dropdown" appearance="fill">
                                        <mat-select panelClass="reason-dropdown-select" [value]="element.suspected_collections_reason_id" [compareWith]="compareReason" (selectionChange)="setElementReason($event.value,element)" placeholder="{{'LIST_COLUMNS.CHOOSE_REASON' | translate}}">
                                            @for (reason of collectionReasonTypes; track reason) {
                                                <mat-option class="no-checkbox reason-option" [value]="reason" rtlDiv>
                                                    {{currentLang != 'iw' ? reason['suspected_collections_reason_name'] : reason['suspected_collections_reason_name_hebrew']}}
                                                </mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                } @else {
                                    <span>—</span>
                                }
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                    </table>
                    <div>
                        <app-pagination [chosenBins]="filteredData" (pageChange)='onPageChange($event)' [filesPerPage]="5"></app-pagination>
                    </div>
                </div>
            </div>
            <div class="btns-container" rtlDiv>
                <div class="cancel-btn" (click)="closeModal()">{{ 'TRUCK_MAP.CANCEL' | translate }}</div>
                <div class="apply-btn" (click)="applyChanges()">{{'TITLES.DELETE' | translate }}</div>
            </div>
        </div>
    </div>
    }
    
    @if (isMobile) {}